<template>
  <v-container>
    <validation-observer v-slot="{ invalid, validate }">

      <form @submit.prevent="validate().then(save())">
        <v-row class="ma-0">
          <v-col cols="12">

            <validation-provider v-slot="{ errors }"
                                 rules="required|min:3"
                                 name="nombre"
            >
              <v-text-field outlined
                            class="mt-3"
                            v-model="customer.name"
                            label="Nombre"
                            color="black"
                            :error-messages="errors"
              ></v-text-field>
            </validation-provider>

            <validation-provider v-slot="{ errors }"
                                 rules="required|digits:10"
                                 name="celular"
            >
              <v-text-field outlined
                            class="mt-3"
                            v-model="customer.phone"
                            label="Celular"
                            color="black"
                            :error-messages="errors"
              ></v-text-field>
            </validation-provider>

            <validation-provider v-slot="{ errors }"
                                 rules="required|min:3"
                                 name="dirección"
            >
              <v-text-field outlined
                            class="mt-3"
                            v-model="customer.address"
                            label="Dirección"
                            color="black"
                            :error-messages="errors"
              ></v-text-field>
            </validation-provider>

            <validation-provider v-slot="{ errors }"
                                 rules="required"
                                 name="etiquetas"
            >
              <v-select outlined
                        class="mt-3"
                        v-model="customer.tags"
                        label="Etiquetas"
                        :items="tagSelectOptions"
                        color="black"
                        :error-messages="errors"
                        multiple
              ></v-select>
            </validation-provider>

            <validation-provider v-slot="{ errors }"
                                 rules="required|min:3"
                                 name="notas"
            >
              <v-textarea outlined
                            class="mt-3"
                            v-model="customer.notes"
                            label="Notas"
                            color="black"
                            :error-messages="errors"
              ></v-textarea>
            </validation-provider>

          </v-col>
        </v-row>

        <v-row>
          <v-col>
            <v-btn class="white--text ma-1"
                   color="black"
                   @click.stop="emitCanceled()"
            >
              Cancelar
            </v-btn>

            <v-btn type="submit"
                   class="white--text ma-1"
                   color="green"
                   :loading="sending.form"
                   :disabled="invalid"
            >
              Guardar
            </v-btn>
          </v-col>
        </v-row>
      </form>
    </validation-observer>
  </v-container>
</template>

<script>
import Parse from "parse";
import {ValidationProvider, ValidationObserver} from "vee-validate"
import {extend, localize} from "vee-validate";
import {digits, min, required} from "vee-validate/dist/rules";
import es from 'vee-validate/dist/locale/es.json'

extend('required', required)
extend('min', min)
extend('digits', digits)

localize('es', es)

export default {
  name: "CustomerForm",
  props: {
    merchantId: {
      type: String,
      required: true
    },
    isUpdating: {
      type: Boolean,
      default: false
    },
    customer: {
      type: Object,
      required: false,
      default: () => ({
        id: '',
        name: '',
        address: '',
        phone: '',
        notes: '',
        tags: [],
      })
    }
  },

  components: {
    ValidationObserver,
    ValidationProvider
  },

  data: () => {
    return {
      sending: {
        form: false,
      },
      tagSelectOptions: [
        'Nuevo', 'Frecuente', 'Premium', 'Foodie', 'Drinker'
      ]
    }
  },

  methods: {
    setSendingFormAsTrue() {
      this.sending.form = true
    },

    setSendingFormAsFalse() {
      this.sending.form = false
    },

    getAction() {
      if (this.isUpdating) {
        return 'updateCustomerST'
      }

      return 'createCustomerST'
    },

    getParams() {
      let params = {
        name: this.customer.name,
        address: this.customer.address,
        phone: this.customer.phone,
        notes: this.customer.notes,
        store: this.merchantId,
        tags: JSON.stringify(this.customer.tags)
      }

      if (this.isUpdating) {
        params.customer = this.customer.id
      }

      return params
    },

    save() {
      this.setSendingFormAsTrue()

      this.runParseCloud(this.getAction(), this.getParams())
          .then(response => this.emitSaved({
            id: response.id,
            name: response.attributes.name,
            address: response.attributes.address,
            phone: response.attributes.phone,
            notes: response.attributes.notes,
            tags: response.attributes.tags,
          }))
          .catch(error => this.showErrorMessage('Error', error.message))
          .finally(() => this.setSendingFormAsFalse())
    },

    runParseCloud(name, params, options = {}) {
      return Parse.Cloud.run(name, params, options)
    },

    emitSaved(customer) {
      this.$emit('customer:saved', customer)
    },

    emitCanceled() {
      this.$emit('customer:canceled')
    },

    showErrorMessage(title, message) {
      this.$snotify.error(message, title, {timeout: 4000, preventDuplicates: true});
    }
  }
}
</script>